import { UserDetails } from "../../types";

export type LoginResponse = {
    success: boolean;
    lockedOut: boolean;
    error?: string;
    userDetails?: UserDetails;
};

export type RegisterRequest = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
};

export type RegisterResponse = {
    success: boolean;
    locked: boolean;
    error?: string | null;
};

export type ChangePasswordResponse = {
    success: boolean;
    error?: string | null;
};

export type ForgotPasswordResponse = {
    success: boolean;
    locked: boolean;
};

export type ResetPasswordResponse = {
    success: boolean;
    tokenExpired: boolean;
};

export type PasswordSetupResponse = {
    success: boolean;
    message?: string;
}

export function objectToFormData(obj: Record<string, any>, form?: FormData, namespace?: string): FormData {
    const formData = form || new FormData();

    for (const [key, value] of Object.entries(obj)) {
        const formKey = namespace ? `${namespace}[${key}]` : key;

        if (value instanceof File || value instanceof Blob) {
            formData.append(formKey, value);
        } else if (Array.isArray(value)) {
            value.forEach((v, i) => {
                formData.append(`${formKey}[${i}]`, v);
            });
        } else if (value !== null && typeof value === "object") {
            objectToFormData(value, formData, formKey);
        } else if (value !== undefined && value !== null) {
            formData.append(formKey, String(value));
        }
    }

    return formData;
}
